module.exports = __webpack_public_path__ + "img/404.324a8939.svg";